module.exports = "/assets/b17c7de11dc440639e3ab03d3fc04e09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/nophoto/hotels-small.jpg
// module id = 494
// module chunks = 0